import classnames from 'classnames'
import React, { useState } from 'react'

import buttonStyles from 'src/components/shared/button/Button.module.css'
import inputClasses from 'src/components/shared/inputs/inputs.module.css'
import { Domain } from 'src/models/Domain'

import icoDomain from '../../assets/icons/ico-domain.svg'
import { DomainChips } from '../DomainChips/DomainChips'

import { DomainSettings } from './DomainSettings'
import classes from './DomainsSettings.module.css'


interface Props {
    domainsList: Domain[]
    setDefaultDomain: (id: number) => void
    createNewDomain: (domain: string) => void
    deleteDomain: (id: number) => void
    refreshDomain: (id: number) => Promise<Domain>
}

export const DomainsSettings: React.FC<Props> = ({ domainsList, createNewDomain, deleteDomain, refreshDomain, setDefaultDomain }: Props) => {
  const [newDomain, setNewDomain] = useState<string>('')

  const createDomain = () => {
    if (!newDomain) return
    createNewDomain(newDomain)
  }

  return ( 
    <section>
      <h3 className={ classes['section-title']}>Domain</h3>
      <div className={ classnames(classes['section-card'], classes['section-info']) }>
        <img className={ classes.icon } src={ icoDomain } alt="Domain icon" width="63" />
        <div className={ classes.details }>
          <h4 className={ classes.subtitle }>More engage with your own domain</h4>
          <p className={ classes.text }>
            Want to use your own domain, please, send request to us. Below you can setup default domain, which will appear on preview builder by default. 
            <span className={ classes['highlighted-accent-3']}> Click on Active to change it on default.</span>
          </p>
        </div>
        <div className={ classes['settings-domains'] }>
          {
            domainsList.length ? (
              domainsList.map((domain, index) => (
                <DomainSettings key={index} domain={domain} refreshDomain={refreshDomain} deleteDomain={deleteDomain} />
              ))
            ) : (
              <div className={ classes['domain-creator'] }>
                <input 
                  type="text" className={classnames(inputClasses.input)}
                  value={newDomain}
                  onChange={(e) => setNewDomain(e.currentTarget.value)}
                  placeholder='Enter your domain'
                />
                <button onClick={createDomain} className={ classnames(buttonStyles['root'], buttonStyles['btn-accent-1']) }>
                  Add new domain
                </button>
              </div>
            )
          }
        </div>
        {/* <div className={ classes.actions }>
          <div className={ classes['domains-list'] }>
            { domainsList.map((domain, key) =>
              <DomainChips
                key={ key }
                domain={ domain }
                setAsDefault={ setDefaultDomain }
              />
            )}
          </div>
          <button
            className={ classnames(buttonStyles['root'], buttonStyles['btn-accent-1']) }
            type="button"
            onClick={ addDomain }
          >Send request</button>
        </div> */}
      </div>
    </section>
  )
}
